const routes = [
  {
    path: '/',
    component: () => import('pages/Index'),
    children: [
      {
        path: '/login',
        component: () => import('pages/login/login')
      },
      {
        path: '/login/signin',
        component: () => import('pages/login/signin.vue')
      },
      {
        path: '/login/forgot',
        component: () => import('pages/login/forgot')
      },
      {
        path: '/dashboard',
        component: () => import('layouts/default'),
        children: [
          {
            path: '/dashboard',
            component: () => import('pages/dashboard/dashboard')
          },
          {
            path: '/bots',
            component: () => import('pages/bots/bots'),
            meta: {
              breadcrumbs: {
                titleKey: 'pages.bots.bots.chatbots',
                paths: [
                  { labelKey: 'pages.bots.bots.chatbots', route: '/bots' }
                ]
              }
            }
          },
          {
            path: '/kanban',
            component: () => import('pages/kanban/kanban'),
            children: [
              {
                path: '/kanban/:boardId',
                name: 'kanban-board',
                component: () => import('components/kanban/KanbanBoard.vue'),
                props: true
              }
            ]
          },
          {
            path: '/profile',
            component: () => import('pages/profile/profile'),
            meta: {
              breadcrumbs: {
                titleKey: 'pages.profile.profile.profile',
                paths: [
                  { labelKey: 'pages.profile.profile.profile', route: '/profile' }
                ]
              }
            }
          },
          {
            path: '/library/',
            component: () => import('pages/library/library'),
            meta: {
              breadcrumbs: {
                titleKey: 'pages.library.library.library',
                paths: [
                  { labelKey: 'pages.library.library.library', route: '/library' }
                ]
              }
            }
          },
          {
            path: '/notification/',
            component: () => import('pages/notification/control'),
            meta: {
              breadcrumbs: {
                titleKey: 'pages.notification.control.notificationControl',
                paths: [
                  { labelKey: 'pages.notification.control.notificationControl', route: '/notification' }
                ]
              }
            }
          },
          {
            path: '/help',
            component: () => import('pages/help/help')
          },
          {
            path: '/realTime',
            component: () => import('pages/realTime/realTime')
          },
          {
            path: '/people',
            component: () => import('pages/people/people')
          },
          {
            path: '/people/:id',
            component: () => import('pages/people/timeline')
          },
          {
            path: '/live',
            component: () => import('pages/live/live'),
            children: [
              {
                path: ':_id?',
                component: () => import('pages/live/room')
              }
            ],
            meta: {
              breadcrumbs: {
                titleKey: 'pages.live.live2.liveChatUpperCase',
                paths: [
                  { labelKey: 'pages.live.live2.liveChatUpperCase', route: '/live' }
                ]
              }
            }
          },
          {
            path: '/analytics',
            component: () => import('pages/analytics/analytics'),
            children: [
              {
                path: '',
                component: () => import('pages/analytics/cards'),
                meta: {
                  breadcrumbs: {
                    titleKey: 'pages.analytics.cards.statistics',
                    help: {
                      tooltipKey: 'pages.analytics.cards.tooltipStatistics',
                      link: 'https://docs.google.com/presentation/d/1m5YT1TciofcxKgqzfWygAYZbAAvWyZFF96ot9nfMD_4/edit?usp=sharing'
                    },
                    paths: [
                      { labelKey: 'pages.analytics.cards.statistics', route: '/analytics' }
                    ]
                  }
                }
              },
              {
                path: 'channels',
                component: () => import('pages/analytics/channels/channels'),
                meta: {
                  breadcrumbs: {
                    titleKey: 'pages.analytics.channels.channels.channelOverview',
                    paths: [
                      { labelKey: 'pages.analytics.channels.channels.statistics', route: '/analytics' },
                      { labelKey: 'pages.analytics.channels.channels.channelOverview', route: '/analytics/channels' }
                    ]
                  }
                }
              },
              {
                path: 'location',
                component: () => import('pages/analytics/location/location'),
                meta: {
                  breadcrumbs: {
                    titleKey: 'pages.analytics.location.location.geolocation',
                    paths: [
                      { labelKey: 'pages.analytics.location.location.statistics', route: '/analytics' },
                      { labelKey: 'pages.analytics.location.location.geolocation', route: '/analytics/location' }
                    ]
                  }
                }
              },
              {
                name: 'locationTable',
                path: '/analytics/location/locationsTable/:type',
                component: () => import('pages/analytics/location/locationsTable'),
                props: true,
                meta: {
                  breadcrumbs: {
                    titleKey: 'pages.analytics.location.location.geolocationAdvanced',
                    paths: [
                      { labelKey: 'pages.analytics.knowledge.knowledge.statistics', route: '/analytics' },
                      { labelKey: 'pages.analytics.location.location.geolocation', route: '/analytics/location' },
                      { labelKey: 'pages.analytics.location.location.geolocationAdvanced', route: '/analytics/location/locationsTable' }
                    ]
                  }
                }
              },
              {
                path: 'attendant',
                component: () => import('pages/analytics/attendant/attendant'),
                meta: {
                  breadcrumbs: {
                    titleKey: 'pages.analytics.attendant.attendant.attendants',
                    paths: [
                      { labelKey: 'pages.analytics.attendant.attendant.statistics', route: '/analytics' },
                      { labelKey: 'pages.analytics.attendant.attendant.attendants', route: '/analytics/attendants' }
                    ]
                  }
                }
              },
              {
                path: 'identifiers',
                component: () => import('pages/analytics/identifiers/identifiers'),
                meta: {
                  breadcrumbs: {
                    titleKey: 'pages.analytics.identifiers.identifiers.customIdentifiers',
                    paths: [
                      { labelKey: 'pages.analytics.identifiers.identifiers.statistics', route: '/analytics' },
                      { labelKey: 'pages.analytics.identifiers.identifiers.customIdentifiers', route: '/analytics/identifiers' }
                    ]
                  }
                }
              },
              {
                path: 'knowledge',
                component: () => import('pages/analytics/knowledge/knowledge'),
                meta: {
                  breadcrumbs: {
                    titleKey: 'pages.analytics.knowledge.knowledge.artificialIntelligence',
                    paths: [
                      { labelKey: 'pages.analytics.knowledge.knowledge.statistics', route: '/analytics' },
                      { labelKey: 'pages.analytics.knowledge.knowledge.artificialIntelligence', route: '/analytics/knowledge' }
                    ]
                  }
                }
              },
              {
                path: 'knowledge/responses',
                component: () => import('pages/analytics/knowledge/responses'),
                meta: {
                  breadcrumbs: {
                    titleKey: 'pages.analytics.knowledge.knowledge.artificialIntelligence',
                    paths: [
                      { labelKey: 'pages.analytics.knowledge.knowledge.statistics', route: '/analytics' },
                      { labelKey: 'pages.analytics.knowledge.knowledge.artificialIntelligence', route: '/analytics/knowledge' },
                      { labelKey: 'pages.analytics.knowledge.knowledge.commonQuestions', route: '/analytics/knowledge/responses' }
                    ]
                  }
                }
              },
              {
                path: 'origin',
                component: () => import('pages/analytics/origin/origin'),
                meta: {
                  breadcrumbs: {
                    titleKey: 'pages.analytics.origin.origin.originAttendance',
                    paths: [
                      { labelKey: 'pages.analytics.origin.origin.statistics', route: '/analytics' },
                      { labelKey: 'pages.analytics.origin.origin.originAttendance', route: '/analytics/origin' }
                    ]
                  }
                }
              },
              {
                path: 'flow',
                component: () => import('pages/analytics/flow/flow'),
                meta: {
                  breadcrumbs: {
                    titleKey: 'pages.analytics.flow.flow.flowAnalysis',
                    paths: [
                      { labelKey: 'pages.analytics.flow.flow.statistics', route: '/analytics' },
                      { labelKey: 'pages.analytics.flow.flow.flowAnalysis', route: '/analytics/flow' }
                    ]
                  }
                }
              }
            ]
          },
          {
            path: '/conversations/:id',
            component: () => import('pages/conversations/conversation'),
            meta: {
              breadcrumbs: {
                titleKey: 'pages.conversations.conversation.conversations',
                paths: [
                  { labelKey: 'pages.conversations.conversation.conversations', route: '/conversations/:id' }
                ]
              }
            }
          },
          {
            path: '/conversations',
            component: () => import('pages/conversations/conversation'),
            meta: {
              breadcrumbs: {
                titleKey: 'pages.conversations.conversation.conversations',
                paths: [
                  { labelKey: 'pages.conversations.conversation.conversations', route: '/conversations' }
                ]
              }
            }
          },
          {
            path: '/flow/advanced/:id',
            component: () => import('pages/flow/flow')
          },
          {
            path: '/flow/viewer/:id',
            component: () => import('pages/flow/viewer')
          },
          {
            path: '/flow/editor/:id',
            component: () => import('pages/flow/editor')
          },
          {
            path: '/knowledge/',
            component: () => import('pages/knowledge/knowledge'),
            meta: {
              breadcrumbs: {
                titleKey: 'pages.knowledge.knowledge.intelligence',
                paths: [
                  { labelKey: 'pages.knowledge.knowledge.intelligence', route: '/knowledge' }
                ]
              }
            }
          },
          {
            path: '/knowledge/knowledge_match',
            component: () => import('pages/knowledge/knowledge_match'),
            meta: {
              breadcrumbs: {
                titleKey: 'pages.knowledge.knowledge.intelligence',
                paths: [
                  { labelKey: 'pages.knowledge.knowledge.intelligence', route: '/knowledge' },
                  { labelKey: 'pages.knowledge.knowledge.card_title', route: '/knowledge/knowledge_match' }
                ]
              }
            }
          },
          {
            path: '/knowledge/genai',
            component: () => import('pages/knowledge/genai'),
            meta: {
              breadcrumbs: {
                titleKey: 'pages.knowledge.knowledge.intelligence',
                paths: [
                  { labelKey: 'pages.knowledge.knowledge.intelligence', route: '/knowledge' },
                  { labelKey: 'pages.knowledge.genai.card_title', route: '/knowledge/genai' }
                ]
              }
            }
          },
          {
            path: '/knowledge/genaiMini',
            component: () => import('pages/knowledge/genaiMini'),
            meta: {
              breadcrumbs: {
                titleKey: 'pages.knowledge.genai.title',
                paths: [
                  { labelKey: 'pages.knowledge.genai.title', route: '/knowledge/genaiMini' }
                ]
              }
            }
          },
          {
            path: '/contacts/people',
            component: () => import('pages/CRM/people'),
            meta: {
              breadcrumbs: {
                titleKey: 'pages.settings.contacts.contacts',
                paths: [
                  { labelKey: 'pages.settings.contacts.contacts', route: '/contacts/people' }
                ]
              }
            }
          },
          {
            name: 'contactAdvancedPeople',
            path: '/contacts/:type/:id',
            component: () => import('pages/CRM/contactAdvanced'),
            meta: {
              breadcrumbs: (store, route) => {
                const lang = store.state.localization.language
                const messages = store.state.localization[lang]
                const routeType = route.params.type === 'people' ? 'people' : 'companies'
                const isCreate = route.params.id === 'create'
                
                if (isCreate) {
                  return {
                    title: messages.pages.settings.contacts.contacts,
                    paths: [
                      { label: messages.pages.settings.contacts.contacts, route: `/contacts/${routeType}/` },
                      { label: messages.pages.crm.contactAdvanced.create, route: `/contacts/${routeType}/create` }
                    ]
                  }
                }
                return {
                  title: messages.pages.settings.contacts.contacts,
                  paths: [
                    { label: messages.pages.settings.contacts.contacts, route: `/contacts/${routeType}` },
                    { label: messages.pages.settings.contacts.data, route: `/contacts/${routeType}/` }
                  ]
                }
              }
            }
          },
          {
            path: '/contacts/companies',
            component: () => import('pages/CRM/companies'),
            meta: {
              breadcrumbs: {
                titleKey: 'pages.settings.contacts.contacts',
                paths: [
                  { labelKey: 'pages.settings.contacts.contacts', route: '/contacts' }
                ]
              }
            }
          },
          {
            name: 'contactAdvancedCompany',
            path: '/contacts/:type/:id',
            component: () => import('pages/CRM/contactAdvanced')
          },
          {
            name: 'contactAdvancedCreatePeople',
            path: '/contacts/:type/:id',
            component: () => import('pages/CRM/contactAdvanced')
          },
          {
            name: 'contactAdvancedCreateCompany',
            path: '/contacts/:type/:id',
            component: () => import('pages/CRM/contactAdvanced')
          },
          {
            path: '/preview/:id',
            component: () => import('pages/preview/preview')
          },
          {
            path: '/settings/',
            component: () => import('pages/settings/settings'),
            meta: {
              breadcrumbs: {
                titleKey: 'pages.settings.settings.preferences',
                paths: [
                  { labelKey: 'pages.settings.settings.preferences', route: '/settings' }
                ]
              }
            }
          },
          {
            path: '/settings/live/',
            component: () => import('pages/settings/live'),
            meta: {
              breadcrumbs: {
                titleKey: 'pages.settings.live.liveChat',
                paths: [
                  { labelKey: 'pages.settings.live.preferences', route: '/settings' },
                  { labelKey: 'pages.settings.live.liveChat', route: '/settings/live' }
                ]
              }
            }
          },
          {
            path: '/settings/live/messages',
            component: () => import('pages/settings/live/messages'),
            meta: {
              breadcrumbs: {
                titleKey: 'pages.settings.live.liveChat',
                paths: [
                  { labelKey: 'pages.settings.live.preferences', route: '/settings' },
                  { labelKey: 'pages.settings.live.liveChat', route: '/settings/live' },
                  { labelKey: 'pages.settings.live.messages', route: '/settings/live' }
                ]
              }
            }
          },
          {
            path: '/settings/live/behavior',
            component: () => import('pages/settings/live/behavior'),
            meta: {
              breadcrumbs: {
                titleKey: 'pages.settings.live.liveChat',
                paths: [
                  { labelKey: 'pages.settings.live.preferences', route: '/settings' },
                  { labelKey: 'pages.settings.live.liveChat', route: '/settings/live' },
                  { labelKey: 'pages.settings.live.behavior', route: '/settings/live/behavior' }
                ]
              }
            }
          },
          {
            path: '/settings/live/departments',
            component: () => import('pages/settings/live/departments'),
            meta: {
              breadcrumbs: {
                titleKey: 'pages.settings.live.liveChat',
                paths: [
                  { labelKey: 'pages.settings.live.preferences', route: '/settings' },
                  { labelKey: 'pages.settings.live.liveChat', route: '/settings/live' },
                  { labelKey: 'pages.settings.live.departments', route: '/settings/live/departments' }
                ]
              }
            }
          },
          {
            path: '/settings/lists/',
            component: () => import('pages/settings/lists'),
            meta: {
              breadcrumbs: {
                titleKey: 'pages.settings.lists.lists',
                paths: [
                  { labelKey: 'pages.settings.settings.preferences', route: '/settings' },
                  { labelKey: 'pages.settings.lists.lists', route: '/settings/lists' }
                ]
              }
            }
          },
          {
            path: '/settings/bases/',
            component: () => import('pages/settings/bases'),
            meta: {
              breadcrumbs: {
                titleKey: 'pages.settings.settings.dataBases',
                paths: [
                  { labelKey: 'pages.settings.settings.preferences', route: '/settings' },
                  { labelKey: 'pages.settings.settings.dataBases', route: '/settings/bases' }
                ]
              }
            }
          },
          {
            path: '/settings/status/',
            component: () => import('pages/settings/status'),
            meta: {
              breadcrumbs: {
                titleKey: 'pages.settings.settings.numberStatus',
                paths: [
                  { labelKey: 'pages.settings.settings.preferences', route: '/settings' },
                  { labelKey: 'pages.settings.settings.numberStatus', route: '/settings/status' }
                ]
              }
            }
          },
          {
            path: '/settings/fields/',
            component: () => import('pages/settings/fields'),
            meta: {
              breadcrumbs: {
                titleKey: 'pages.settings.settings.customFields',
                paths: [
                  { labelKey: 'pages.settings.settings.preferences', route: '/settings' },
                  { labelKey: 'pages.settings.settings.customFields', route: '/settings/fields' }
                ]
              }
            }
          },
          {
            path: '/settings/chatbot/:id',
            component: () => import('pages/settings/chatbot'),
            meta: {
              breadcrumbs: {
                titleKey: 'pages.settings.chatbot.chatbots',
                paths: [
                  { labelKey: 'pages.settings.chatbot.chatbots', route: '/settings/chatbot/:id' }
                ]
              }
            }
          },
          {
            path: '/settings/chatbot/:id/behavior',
            component: () => import('pages/settings/chatbot/behavior'),
            meta: {
              breadcrumbs: {
                titleKey: 'pages.settings.chatbot.behavior.behavior',
                paths: [
                  { labelKey: 'pages.settings.chatbot.chatbots', route: '/bots' },
                  { labelKey: 'pages.settings.settings.preferences', route: '/settings/chatbot/:id' },
                  { labelKey: 'pages.settings.chatbot.behavior.behavior', route: '/settings/chatbot/:id/behavior' }
                ]
              }
            }
          },
          {
            path: '/settings/chatbot/:id/whatsapp',
            component: () => import('pages/settings/chatbot/whatsapp'),
            meta: {
              breadcrumbs: {
                titleKey: 'pages.settings.chatbot.behavior.behavior',
                paths: [
                  { labelKey: 'pages.settings.chatbot.chatbots', route: '/bots' },
                  { labelKey: 'pages.settings.settings.preferences', route: '/settings/chatbot/:id' },
                  { labelKey: 'pages.settings.chatbot.whatsappChatbot', route: '/settings/chatbot/:id/whatsapp' }
                ]
              }
            }
          },
          {
            path: '/settings/chatbot/:id/installation',
            component: () => import('pages/settings/chatbot/installation'),
            meta: {
              breadcrumbs: {
                titleKey: 'pages.settings.chatbot.behavior.behavior',
                paths: [
                  { labelKey: 'pages.settings.chatbot.chatbots', route: '/bots' },
                  { labelKey: 'pages.settings.settings.preferences', route: '/settings/chatbot/:id' },
                  { labelKey: 'pages.settings.chatbot.installation.installation', route: '/settings/chatbot/:id/installation' }
                ]
              }
            }
          },
          {
            path: '/settings/chatbot/:id/integrations',
            component: () => import('pages/settings/chatbot/integrations'),
            meta: {
              breadcrumbs: {
                titleKey: 'pages.settings.chatbot.master.master',
                paths: [
                  { labelKey: 'pages.settings.chatbot.chatbots', route: '/bots' },
                  { labelKey: 'pages.settings.chatbot.preferences', route: '/settings/chatbot/:id' },
                  { labelKey: 'pages.settings.chatbot.integrations.integrations', route: '/settings/chatbot/:id/integrations' }
                ]
              }
            }
          },
          {
            path: '/settings/chatbot/:id/data-collection',
            component: () => import('pages/settings/chatbot/data-collection'),
            meta: {
              breadcrumbs: {
                titleKey: 'pages.settings.chatbot.master.master',
                paths: [
                  { labelKey: 'pages.settings.chatbot.chatbots', route: '/bots' },
                  { labelKey: 'pages.settings.chatbot.preferences', route: '/settings/chatbot/:id' },
                  { labelKey: 'pages.settings.chatbot.dataCollection', route: '/settings/chatbot/:id/collection-data' }
                ]
              }
            }
          },
          {
            path: '/settings/chatbot/:id/interface',
            component: () => import('pages/settings/chatbot/interface'),
            meta: {
              breadcrumbs: {
                titleKey: 'pages.settings.chatbot.behavior.behavior',
                paths: [
                  { labelKey: 'pages.settings.chatbot.chatbots', route: '/bots' },
                  { labelKey: 'pages.settings.settings.preferences', route: '/settings/chatbot/:id' },
                  { labelKey: 'pages.settings.chatbot.interface.interface', route: '/settings/chatbot/:id/interface' }
                ]
              }
            }
          },
          {
            path: '/settings/chatbot/:id/master',
            component: () => import('pages/settings/chatbot/master'),
            meta: {
              breadcrumbs: {
                titleKey: 'pages.settings.chatbot.master.master',
                paths: [
                  { labelKey: 'pages.settings.chatbot.chatbots', route: '/bots' },
                  { labelKey: 'pages.settings.chatbot.preferences', route: '/settings/chatbot/:id' },
                  { labelKey: 'pages.settings.chatbot.master.master', route: '/settings/chatbot/:id/master' }
                ]
              }
            }
          },
          {
            path: '/settings/chatbot/:id/messages',
            component: () => import('pages/settings/chatbot/messages'),
            meta: {
              breadcrumbs: {
                titleKey: 'pages.settings.chatbot.messages.messages',
                paths: [
                  { labelKey: 'pages.settings.chatbot.chatbots', route: '/bots' },
                  { labelKey: 'pages.settings.chatbot.preferences', route: '/settings/chatbot/:id' },
                  { labelKey: 'pages.settings.chatbot.messages.messages', route: '/settings/chatbot/:id/messages' }
                ]
              }
            }
          },
          {
            path: '/settings/chatbot/:id/publish',
            component: () => import('pages/settings/chatbot/publish'),
            meta: {
              breadcrumbs: {
                titleKey: 'pages.settings.chatbot.master.master',
                paths: [
                  { labelKey: 'pages.settings.chatbot.chatbots', route: '/bots' },
                  { labelKey: 'pages.settings.chatbot.preferences', route: '/settings/chatbot/:id' },
                  { label: 'Versionamento', route: '/settings/chatbot/:id/publish' }
                ]
              }
            }
          },
          {
            path: '/settings/users',
            component: () => import('pages/settings/users'),
            meta: {
              breadcrumbs: {
                titleKey: 'pages.settings.users.users',
                paths: [
                  { labelKey: 'pages.settings.settings.preferences', route: '/settings' },
                  { labelKey: 'pages.settings.users.users', route: '/settings/users' }
                ]
              }
            }
          },
          {
            name: 'settings.domains',
            path: '/settings/domains',
            component: () => import('pages/settings/domains'),
            meta: {
              breadcrumbs: {
                titleKey: 'pages.settings.domains.domains',
                paths: [
                  { labelKey: 'pages.settings.settings.preferences', route: '/settings' },
                  { labelKey: 'pages.settings.domains.domains', route: '/settings/domains' }
                ]
              }
            }
          },
          {
            name: 'settings.domains.unsubscribeGroups',
            path: '/settings/domains/:authorizedDomainId/unsubscribe-groups',
            component: () => import('pages/settings/domains/UnsubscribeGroups.vue'),
            meta: {
              breadcrumbs: {
                titleKey: 'pages.settings.unsubscribeGroups.title',
                paths: [
                  { labelKey: 'pages.settings.settings.preferences', route: '/settings' },
                  { labelKey: 'pages.settings.domains.domains', route: '/settings/domains' },
                  { labelKey: 'pages.settings.unsubscribeGroups.title', route: '/settings/domains/:authorizedDomainId/unsubscribe-groups' }
                ]
              }
            }
          },
          {
            path: '/settings/tags',
            component: () => import('pages/settings/tags'),
            meta: {
              breadcrumbs: {
                titleKey: 'pages.settings.tags.tags',
                paths: [
                  { labelKey: 'pages.settings.settings.preferences', route: '/settings' },
                  { labelKey: 'pages.settings.tags.tags', route: '/settings/tags' }
                ]
              }
            }
          },
          {
            path: '/settings/optout/',
            component: () => import('pages/settings/optout'),
            meta: {
              breadcrumbs: {
                titleKey: 'pages.settings.settings.numberStatus',
                paths: [
                  { labelKey: 'pages.settings.settings.preferences', route: '/settings' },
                  { labelKey: 'pages.settings.settings.optout', route: '/settings/optout' }
                ]
              }
            }
          },
          {
            path: '/settings/access/control',
            component: () => import('pages/settings/users/access'),
            meta: {
              breadcrumbs: {
                titleKey: 'pages.settings.users.access.journey',
                paths: [
                  { labelKey: 'pages.settings.settings.preferences', route: '/settings' },
                  { labelKey: 'pages.settings.users.access.journey', route: '/settings/access/control' }
                ]
              }
            }
          },
          {
            path: '/settings/whatsapp-consumption',
            name: 'settings.whatsappConsumption',
            component: () => import('pages/settings/whatsapp-consumption'),
            meta: {
              breadcrumbs: {
                titleKey: 'pages.settings.settings.whatsappConsumption',
                paths: [
                  { labelKey: 'pages.settings.settings.preferences', route: '/settings' },
                  { labelKey: 'pages.settings.settings.whatsappConsumption', route: '/settings/whatsapp-consumption' }
                ]
              }
            }
          },
          {
            path: '/broadcast/:id',
            component: () => import('pages/broadcast/broadcast'),
            meta: {
              breadcrumbs: {
                titleKey: 'pages.broadcast.broadcast2.campaigns',
                paths: [
                  { labelKey: 'pages.broadcast.broadcast2.campaigns', route: '/broadcast/:id' }
                ]
              }
            }
          },
          {
            path: '/broadcast/',
            component: () => import('pages/broadcast/broadcast'),
            meta: {
              breadcrumbs: {
                titleKey: 'pages.broadcast.broadcast2.campaigns',
                paths: [
                  { labelKey: 'pages.broadcast.broadcast2.campaigns', route: '/broadcast' }
                ]
              }
            }
          },
          {
            path: '/advanced',
            component: () => import('pages/advanced/list'),
            meta: {
              breadcrumbs: {
                titleKey: 'pages.advanced.list.listClients',
                paths: [
                  { labelKey: 'pages.advanced.list.listClients', route: '/advanced' }
                ]
              }
            }
          },
          {
            name: 'advanced',
            path: '/advanced/:id',
            component: () => import('pages/advanced/edit'),
            meta: {
              breadcrumbs: (store, route) => {
                const lang = store.state.localization.language
                const messages = store.state.localization[lang].pages.advanced.edit
                const name = route.query.name || ''
                return {
                  title: messages.editAccount,
                  paths: [
                    { label: messages.clientsList, route: '/advanced' },
                    { label: messages.editAccountTwo + name, route: '/advanced/' }
                  ]
                }
              }
            }
          },
          {
            path: '/advanced/logs/list',
            component: () => import('pages/advanced/logs/list'),
            meta: {
              breadcrumbs: {
                title: 'Change Logs',
                paths: [
                  { label: 'Change Logs', route: '/advanced/logs/list' }
                ]
              }
            }
          },
          {
            path: '/advanced/copilot',
            component: () => import('pages/advanced/copilot'),
            meta: {
              breadcrumbs: {
                title: 'Copiloto Analytics',
                paths: [
                  { label: 'Copiloto Analytics', route: '/advanced/copilot' }
                ]
              }
            }
          },
          {
            name: 'advanced.emailUnsubscribes',
            path: '/advanced/email-unsubscribes',
            component: () => import('pages/advanced/EmailUnsubscribes.vue'),
            meta: {
              // Só supermaster (permission 10 + isEmployee); o guard em router/index.js aplica.
              supermasterOnly: true,
              breadcrumbs: {
                titleKey: 'pages.advanced.emailUnsubscribes.title',
                paths: [
                  { labelKey: 'pages.advanced.emailUnsubscribes.title', route: '/advanced/email-unsubscribes' }
                ]
              }
            }
          },
          {
            path: '/conversation',
            component: () => import('pages/advanced/conversation'),
            meta: {
              breadcrumbs: {
                titleKey: 'pages.advanced.conversation.conversationDetails',
                paths: [
                  { labelKey: 'pages.advanced.conversation.conversationDetails', route: '/conversation' }
                ]
              }
            }
          },
          {
            path: '/action/create',
            component: () => import('pages/actions/create'),
            meta: {
              breadcrumbs: {
                titleKey: 'pages.actions.create.addAction',
                paths: [
                  { labelKey: 'pages.actions.list.addAction', route: '/action' },
                  { labelKey: 'pages.actions.create.addAction', route: '' }
                ]
              }
            }
          },
          {
            path: '/consumption',
            component: () => import('pages/consumption/index'),
            meta: {
              breadcrumbs: {
                titleKey: 'pages.consumption.list.clientsConsumption',
                paths: [
                  { labelKey: 'pages.consumption.list.clientsConsumption', route: '/consumption' }
                ]
              }
            }
          }
        ]
      }
    ]
  },
  // Always leave this as last one,
  // but you can also remove it
  {
    path: '/:catchAll(.*)*',
    component: () => import('pages/Error404.vue')
  }
]

export default routes
